import tree from "../../../../components/tree.vue"
import iColumn from "../../../../components/Column.vue";
import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import { sortRule } from '@/utility/index.js'

export default {
    components: { tree, iColumn, iTable, IPagination },
    data() {
        return {
            formInline: {
                dictValue: '',
                dictAdditionalValue: ''
            },
            dialogVisible: false,
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "dictId",
                    label: this.$t('DictionaryManaged.dictId'),
                    align: "center",
                },
                {
                    prop: "dictValue",
                    label: this.$t('DictionaryManaged.dictValue'),
                    align: "center",
                },
                {
                    prop: "dictAdditionalValue",
                    label: this.$t('DictionaryManaged.dictAdditionalValue'),
                    align: "center",
                },
                {
                    prop: "dictSort",
                    label: this.$t('DictionaryManaged.dictSort'),
                    align: "center",
                },
                {
                    prop: "remarks",
                    label: this.$t('common.remark'),
                    align: "center",
                },
                {
                    prop: "createTime",
                    label: this.$t('common.setUpTime'),
                    align: "center",
                    width: "300",
                }
            ],
            operates: {
                width: 60,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            btnType: '',
            rules: {
                dictValue: [
                    { required: true, message: this.$t('DictionaryManaged.form.dictValue'), trigger: 'blur' },
                ],
                dictSort: [
                    { required: true, validator: sortRule, trigger: 'blur' }
                ],
            },
            form: {
                dictValue: '',
                dictAdditionalValue: '',
                dictSort: '',
                remarks: '',
            },
            selected: [],
            dictId: ''
        };
    },

    created() {

    },
    mounted() {
        console.log(this.$route.query)
        if (this.$route.query.dictId) {
            this.dictId = this.$route.query.dictId
        }
        this.getDictValue()
    },
    methods: {
        goback() {
            this.$router.push({
                path: "/BackgroundSettings/DictionaryManaged",
                query: {},
            });
        },
        getDictValue() {
            let param = {
                id: this.dictId,
                dictValue: this.formInline.dictValue,
                dictAdditionalValue: this.formInline.dictAdditionalValue,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            this.$store.dispatch('DictionaryManaged/GET_GETDICTVALUE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            })
        },
        onSearch() {
            this.currentPage = 1
            this.getDictValue()
        },
        onClear() {
            this.formInline = {
                dictValue: '',
                dictAdditionalValue: ''
            }
            this.getDictValue()
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getDictValue();
        },
        addUser() {
            this.dialogFormVisible = true;
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })

        },
        editUser() {
            this.dialogFormVisible = true;
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.form.dictValue = this.selected[0].dictValue
                this.form.dictAdditionalValue = this.selected[0].dictAdditionalValue
                this.form.dictSort = this.selected[0].dictSort
                this.form.remarks = this.selected[0].remarks
            })


        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        dictId: this.dictId,
                        dictValue: this.form.dictValue,
                        dictAdditionalValue: this.form.dictAdditionalValue,
                        dictSort: this.form.dictSort,
                        remarks: this.form.remarks,
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('DictionaryManaged/GET_ADDDICTVALUE', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getDictValue();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        param.id = this.selected[0].id
                        this.$store.dispatch('DictionaryManaged/GET_UPDATEDICTVALUE', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getDictValue();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }
                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                dictValue: '',
                dictAdditionalValue: '',
                dictSort: '',
                remarks: '',
            }
        },
        closeDia() {
            this.form = {
                dictValue: '',
                dictAdditionalValue: '',
                dictSort: '',
                remarks: '',
            }
            this.dialogFormVisible = false;
        },

        deleteUser() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { id: this.selected[0].id }
                    this.$store.dispatch('DictionaryManaged/GET_DELETEDICTVALUE', param).then(response => {
                        if (response.data.code == 200) {
                            this.getDictValue()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },

        changeSort(item) {
            this.columns = [];
            this.$nextTick(function () {
                this.columns = item;
            });
        },

        ListSetting() {
            this.$refs.listSet.dialogVisible = true;
        },
    },
};
